<template>
  <div role="navigation" :class="[baseCss, app ? 'bcq-app-level' : null, dense ? ['p-0', 'px-2'] : 'p-1', `shadow-${elevation}${tag === 'footer' ? '-up' : ''}`, setTextColor(), setBgColor(), isApp]" :is="tag" :style="{zIndex}">
    <table-layout equal-cells :style="{height}">
      <row>
        <slot />
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Toolbar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('toolbar', ['select-none', 'block', 'duration-300', 'transition-all'])
    }
  },
  computed: {
    isApp () {
      return this.app ? ['fixed', 'bcq-toolbar-app', 'right-0', 'left-0', this.tag !== 'footer' ? 'top-0' : 'bottom-0'] : null
    }
  },
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    dense: {
      type: Boolean
    },
    app: {
      type: Boolean
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    color: {
      type: String,
      default: 'black'
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    height: {
      type: String
    }
  }
}
</script>
<style>
.bcq-toolbar .bcq-table-layout
{
  min-height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/toolbar/toolbar.vue